import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuditTrailService {
  private _auditTrailData: BehaviorSubject<any> = new BehaviorSubject(null);

  /**
   * Constructor
   */
  constructor(private _httpClient: HttpClient,private authService: AuthService ) {
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for data
   */
  get auditTrailData$(): Observable<any> {
    return this._auditTrailData.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Get data
   */
  getData(pageNumber :any, pageSize :any, wellName: any, startDate :any): Observable<any> {
    const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': '',
        // Add any other required headers
      });

    let Params = new HttpParams()

    Params = Params.append('pageNumber', pageNumber);
    Params = Params.append('pageSize', pageSize);
    Params = Params.append('wellName', wellName);
    Params = Params.append('startDate', startDate);

      
    return this._httpClient.get<any>(`${environment.apiURL}/${environment.apiVersion}/AuditTrail/SubmissionAuditTrail`,{headers : headers,params : Params}).pipe(
      tap((response: any) => {
        this._auditTrailData.next(response);
      }),
    );
  }
}
